import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import useTokenStore from "store/tokenStore";

const saveBlob = (blob, filename) => {
	const url = window.URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = filename || "book_metrics.xlsx";
	document.body.appendChild(a);
	a.click();
	a.remove();
	window.URL.revokeObjectURL(url);
};

const getFilenameFromHeader = (contentDisposition) => {
	if (!contentDisposition) return null;
	const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(contentDisposition);
	return decodeURIComponent(match?.[1] || match?.[2] || "");
};

const useExportBookMetrics = () => {
	const { accessToken } = useTokenStore();
	const history = useHistory();

	const exportMetrics = async ({ from, to }) => {
		const instance = await InitApi({ accessToken });
		const res = await instance.get(`/admin/books/metrics/export`, {
			params: { from, to },
			responseType: "blob",
		});
		const filename = getFilenameFromHeader(res.headers["content-disposition"]) || `book_metrics_${from}_to_${to}.xlsx`;
		saveBlob(res.data, filename);
		return res;
	};

	return useMutation(exportMetrics, {
		onSuccess: async () => {
			toast.success("Export generated.");
		},
		onError: async (error) => {
			const message = error?.response?.data?.message || "Export failed";
			toast.error(
				<ServerErrors
					errorMessage={message}
					errors={error?.response?.data?.data}
				/>,
				{ className: "max-w-max" }
			);

			if (error?.response?.data?.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
		},
	});
};

export default useExportBookMetrics;
